import React, { useEffect, useState } from "react";
import AddUserForm from "./UserForm";
import { PREFERED_LANGUAGE_KEYS, USER_ROLES } from "../../App.config";


const UserFormComponent = (props) => {


    const getDepartmentByRegionId = (regionId) => {
        props.userAuthAction.getDepartmentByRegionId(regionId);
    }

    const getLevelItem = (levelId) => {
        props.userAuthAction.getLevelItemByLevelId(levelId,props.userAuthReducer ? props.userAuthReducer.selectedCompany : null);
    }

    const getRegionByCompanyId = () => {
        props.userAuthAction.getRegionByCompanyId(props.userAuthReducer ? props.userAuthReducer.selectedCompany : null);
    }

    const getAllDomainList = () => {
        props.userAuthAction.getAllDomainList(props.userAuthReducer ? props.userAuthReducer.selectedCompany : null);
    }

    const resetDomainList = (domainList) => {
        props.userAuthAction.resetDomainList(domainList);
    }

    const getBackupUsers = (departmentId) => {
        props.userAuthAction.getBackupUsers(departmentId);
    }

    const resetBackupUserFlag = (BackupUserFlag) => {
        props.userAuthAction.resetBackupUserFlag(BackupUserFlag);
    }

    const resetAuthUser = () => {
        props.userAuthAction.resetAuthUser();
    }

    const handleSubmit = (userdata) => {
        let managerSelectedCompanyIds = [];
        userdata && userdata.selectedCompanys && Array.isArray(userdata.selectedCompanys) && userdata.selectedCompanys.map((company,index)=>{
            managerSelectedCompanyIds.push(company.value);
        }) 
        // let gender = userdata.gender == "true" ? true : false;
        let emailAddress = userdata.emailUsername + "@" + userdata.domain
        let authUserId = props.formData ? props.formData.authUserId : null;
        let payload = {
            "authUserId": authUserId,
            "firstName": userdata.firstName,
            "lastName": userdata.lastName,
            // "userCode": userdata.userCode,
            "password": userdata.password,
            "phone": userdata.contact,
            "email": emailAddress,
            "userRoleId": userdata.userRoleId,
            // "companyId": props.userAuthReducer && props.userAuthReducer.selectedCompany && !managerSelectedCompanyIds.length>0 ? [props.userAuthReducer.selectedCompany.toString()] : null,
            "languagePreference": props.profileReducer && props.profileReducer.managersDetails ? props.profileReducer.managersDetails.languagePreference : null,
            // "gender": gender,
            "passwordExpiryPeriod": userdata.passwordExpiry,
            "departmentId": userdata.userRoleId != USER_ROLES.ADMIN ? parseInt(userdata.departmentId):null,
            "regionId": userdata.userRoleId != USER_ROLES.ADMIN ? parseInt(userdata.regionId):null,
            "ein": userdata.ein,
            "isLangEng": props.in18Reducer.lang === PREFERED_LANGUAGE_KEYS.EnglishUS ? true : false,
            "lstCompanyAssigned": props.userAuthReducer && props.userAuthReducer.selectedCompany && !managerSelectedCompanyIds.length>0 ? [props.userAuthReducer.selectedCompany.toString()] : managerSelectedCompanyIds
            // "backupUserId":parseInt(userdata.backupUserId)
        }
        props.userAuthAction.addUser(payload);
        // resetAuthUser();
    }
    return (
        <>
            <AddUserForm
                {...props}
                handleSubmit={handleSubmit}
                getDepartmentByRegionId={getDepartmentByRegionId}
                getAllDomainList={getAllDomainList}
                getBackupUsers={getBackupUsers}
                resetBackupUserFlag={resetBackupUserFlag}
                resetAuthUser={resetAuthUser}
                getRegionByCompanyId={getRegionByCompanyId}
                getLevelItem={getLevelItem}
            />
        </>
    );
};
export default UserFormComponent;
